import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext/AuthContext';
import { TabProvider } from './context/TabContext/TabContext';
import { AccessControlProvider } from './context/AccessControlContext/AccessControlContext';

import Router from './Router';
import Layout from './components/layouts/Layout/Layout';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProviderComponent } from './context/ThemeContext/ThemeContext';
import { WalletProvider } from './context/WalletContext/WalletContext';
import TrackingPixels from './utils/pixel/TrackingPixels';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import MaintenanceGate from './components/Maintenance/MaintenanceGate';
import CookieBanner from './components/CookieBanner/CookieBanner';

import { GoogleOAuthProvider } from '@react-oauth/google';

// The Google SDK throws "Missing required parameter client_id" while the login page mounts when
// the client id is empty, which blanks the whole page. A placeholder keeps the page alive when the
// build was made without it; ThirdPartyAuthButtons hides the Google button in that case.
const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID?.trim() || 'google-login-disabled.apps.googleusercontent.com';

export default function App() {
  return (
    <BrowserRouter>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <AccessControlProvider>
          {/* Outside MaintenanceGate on purpose: consent must not depend on the API being up,
              otherwise a visitor arriving during an outage can never accept or refuse. */}
          <CookieBanner />
          {/* Above every provider: while the API is down nothing below mounts, so no component
              keeps retrying calls that cannot succeed. */}
          <MaintenanceGate>
            <div className="App">
              <AuthProvider>
                <TrackingPixels />
                <ScrollToTop />
                <WalletProvider>
                  <ThemeProviderComponent>
                    <TabProvider>
                      <Layout>
                        <Router />
                      </Layout>
                    </TabProvider>
                  </ThemeProviderComponent>
                </WalletProvider>
              </AuthProvider>
            </div>
            <ToastContainer />
          </MaintenanceGate>
        </AccessControlProvider>
      </GoogleOAuthProvider>
    </BrowserRouter>
  );
}
